import { Box, Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useContext, useEffect, useState } from "react";
import { CustomGridToolbarQuickFilter } from "../../../components/datagrid/CustomGridToolbarQuickFilter";
import { MenuData } from "../../../components/input/CustomSelect";
import { MultipleAutoComplete } from "../../../components/input/MutipleAutoComplete";
import { EcoEfficiencyContext } from "../../../contexts/EcoEfficiencyContext";
import { OrganizationContext } from "../../../contexts/OrganizationContext";
import { common, input } from "../../../i18n";
import { useAuth } from "../../../contexts/UserContext";
import ArrayUtils from "../../../utils/arrayUtils";

export const QuickSearchToolbar = () => {
  const { control, setValue, watch } = useForm();

  const organizationContext = useContext(OrganizationContext);

  const { isAdmin } = useAuth();

  const isUserAdmin = isAdmin();

  const {
    filterSubOrganization,
    setFilterSubOrganization,
    setModalIsOpen,
    setEditData,
    addEcoEfficiencyForm,
    searchText,
    setSearchText,
  } = EcoEfficiencyContext();

  const filter = watch("subOrganization");

  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const [subOrganizations, setSubOrganizations] = useState<MenuData[]>([]);

  useEffect(() => {
    if (
      organizationContext &&
      organizationContext.subOrganizations &&
      organizationContext.organization
    ) {
      const mainOrgLabel = `${organizationContext.organization.name} (บริษัทหลัก)`;
      let temp: MenuData[] = [
        {
          nameEN: mainOrgLabel,
          nameTH: mainOrgLabel,
          value: organizationContext.organization._id,
        },
        ...ArrayUtils.convertArrayToMenuData(
          "refId",
          "name",
          "name",
          organizationContext.subOrganizations,
        ),
      ];

      if (!isUserAdmin) {
        temp = temp.slice(1);
      }

      setSubOrganizations(temp);

      const selectedValues = filterSubOrganization?.length
        ? temp
            .filter((t) => filterSubOrganization.includes(t.value))
            .map((t) => t.value)
        : temp.map((t) => t.value);

      setValue("subOrganization", selectedValues);

      setFilterSubOrganization(temp.map((t) => t.value));
    }
    // organizationContext is a fresh object every render (unmemoized) — depend
    // on the specific fields read here so an unrelated ancestor re-render
    // doesn't reset the user's filter selection back to "all".
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    organizationContext?.subOrganizations,
    organizationContext?.organization,
    isUserAdmin,
  ]);

  useEffect(() => {
    setFilterSubOrganization(filter ?? []);
  }, [filter, setFilterSubOrganization]);

  return (
    <Box marginBottom={"40px"} pt={"8px"}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={12} sm="auto">
          <CustomGridToolbarQuickFilter
            value={searchText}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setSearchText(event.currentTarget.value)
            }
          />
        </Grid>

        <Grid item xs={12} sm={12} md={4} sx={{ zIndex: 8 }}>
          <MultipleAutoComplete
            required
            showLabelInput={false}
            name={"subOrganization"}
            control={control}
            rules={{
              required: t("This-field-is-required", {
                param: t("Organizations"),
              }),
            }}
            label={`${t("Organizations")} / ${t("Sub-Organizations")}`}
            info={`${t("Organizations")} / ${t("Sub-Organizations")}`}
            placeholder={t("Select-Param", {
              param: t("Organizations"),
            })}
            listMenuItem={subOrganizations}
            defaultValue={[]}
            storeValue
          />
        </Grid>

        <Grid item xs={12} sm={"auto"} sx={{ ml: { sm: "auto" } }}>
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            startIcon={<img src="/img/add-circle.svg" alt="add-circle" />}
            onClick={() => {
              addEcoEfficiencyForm.reset();
              setEditData(undefined);
              setModalIsOpen(true);
            }}
          >
            {t("Add-Eco-Efficiency")}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
